import { CardTemplate, BlankTemplate, DefaultTemplate } from '@bingads-webui-react/wizard-ui-library';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import {
  LanguageCountryStepShimmer,
  WebsiteStepShimmer,
  CampaignModeStepShimmer,
} from '@bingads-webui-campaign-react/pmax-lite-shimmers';

import { withLoadingState } from './with-loading-state';
import { ProcessingBlocker } from './processing-blocker';
import { PreviewFlowTemplate } from './preview-flow-template';
import { PreviewFlowStepList } from './preview-flow-step-list';

export const layoutConfig = {
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD]: {
    template: CardTemplate,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.COLLECT_BUSINESS_INFO]: {
    template: CardTemplate,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.LANGUAGE_COUNTRY]: {
    template: CardTemplate,
    customShimmer: withLoadingState(LanguageCountryStepShimmer),
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.WEBSITE]: {
    template: CardTemplate,
    customShimmer: withLoadingState(WebsiteStepShimmer),
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.GOOGLE_IMPORT]: {
    template: BlankTemplate,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.FACEBOOK_IMPORT]: {
    template: BlankTemplate,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_SIGNUP]: {
    template: CardTemplate,
    customBlocker: ProcessingBlocker,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_EDITOR]: {
    template: DefaultTemplate,
    noStepList: true,
    customBlocker: ProcessingBlocker,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_CUSTOM_DOMAIN]: {
    template: DefaultTemplate,
    noStepList: true,
    customBlocker: ProcessingBlocker,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_MODE]: {
    template: CardTemplate,
    customShimmer: withLoadingState(CampaignModeStepShimmer),
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.AD_ASSETS]: {
    template: DefaultTemplate,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.TARGETING]: {
    template: DefaultTemplate,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.BUDGET]: {
    template: DefaultTemplate,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ASSETS]: {
    template: PreviewFlowTemplate,
    customStepList: PreviewFlowStepList,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.ACCOUNT_DETAILS]: {
    template: DefaultTemplate,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.PAYMENT]: {
    template: DefaultTemplate,
    customBlocker: ProcessingBlocker,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.ADD_FUNDS]: {
    template: DefaultTemplate,
    customBlocker: ProcessingBlocker,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ACCOUNT]: {
    template: PreviewFlowTemplate,
    customStepList: PreviewFlowStepList,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_PAYMENT]: {
    template: PreviewFlowTemplate,
    customStepList: PreviewFlowStepList,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ADD_FUNDS]: {
    template: PreviewFlowTemplate,
    customStepList: PreviewFlowStepList,
  },
  [PMAX_LITE_WIZARD_STEP_PATHS.CONVERSION_UPSELL]: {
    template: DefaultTemplate,
    noStepList: true,
  },
};
